import api from "core/api/api";
import _ from "underscore";
import { template, className, modelEvent, regions } from "core/decorators";
import { LayoutView, CompositeView } from "marionette";
import App from "app";
import Backbone from "backbone";
import ConnectionValidationTemplate from "./templates/schema-validation-template.template.html";
import ConnectionValidationEntryTemplate from "./templates/connection-test-entry-template.html";
import * as Models from "./models";
import { DB_PROVIDERS } from "./configs/db-providers";
import { getParams } from "../../../../../../../src/modules/wizards/services";
import { isAutomatedWizard } from "./app-services";
import Tracker from "../../../../../../../core/services/tracker/tracker";
import { TRACKER_STRINGS } from "../../../../../../../core/services/tracker/constants";
import SchemaValidationProgressBarReactView from "./source-wizard-react-view/schema-validation-progress-bar/schema-validation-progress-bar";
import InlineHelpMarionetteContainer from "../inline-help-container";
import MarionetteWrapper from "../../../../../marionette-wrapper-for-react";

const statusKeys = {
    FETCHING: "isFetchingMetaDataSuccess",
    VALIDATING: "isValidatingTablesSuccess"
};
import { getNameAndSchema } from "src/modules/wizards/services/wizards-methods-helper";
@template(ConnectionValidationEntryTemplate)
class ConnectionValidationEntry extends LayoutView {
    @modelEvent("change")
    modelChanged() {
        this.render();
    }

    onRender() {
        if (this.model.get("status") === "fail") {
            this.$el.find(".connection-remedy").slideDown("fast");
        }
    }
}

@className("connection-test-view card")
@template(ConnectionValidationTemplate)
@regions({
    container: "#connection-test-container"
})
export default class SchemaMigrationValidation extends InlineHelpMarionetteContainer {
    initialize() {
        App.vent.trigger("appwizard:next:disable");
        App.vent.trigger("appwizard:back:enable");
        let model = App.reqres.request("get:wizard:model");
        this.model = model;
        this.failed = false;

        let selectedSchemas = this.model.get("schemas").where({ isEnabled: true });
        this.selectedSchemas = selectedSchemas;
        this.collection = new Backbone.Collection();
        const isValidationSupported = this.model.get("isValidationSupported") ?? false;
        const validationSteps = [
            {
                id: 0,
                title: "Fetching Metadata about Schemas",
                method: this.fetchTables.bind(this),
                statusKey: statusKeys.FETCHING,
                errors: false
            },
            ...(isValidationSupported
                ? [
                      {
                          id: 1,
                          title: "Validating Tables",
                          method: this.checkTableCompatibility.bind(this),
                          statusKey: statusKeys.VALIDATING,
                          errors: false
                      }
                  ]
                : [])
        ];

        this.validationSteps = validationSteps;
        const type = this.model.get("type").toLowerCase();
        const ID = type + "-validate-schemas";
        super.initialize(ID);

        App.vent.on("appwizard:retry:schema-validation", () => {
            // this.failed = false;
            // this.proceedTo(0);
        });

        Tracker.getInstance().track(TRACKER_STRINGS.schema.schemaSelection, {
            event: "Wizards:Select Schemas",
            schemaCount: selectedSchemas.length,
            isAutomatedWizard: isAutomatedWizard()
        });
    }

    onRender() {
        const currentPage = `validate-${this.model.get("whatsInside")?.toLowerCase()}`;
        const SchemaMigrationValidationView = MarionetteWrapper(SchemaValidationProgressBarReactView, {
            validationSteps: this.validationSteps,
            selectedSchemas: this.selectedSchemas,
            currentStep: currentPage
        });
        setTimeout(() => {
            this.getRegion("container").show(SchemaMigrationValidationView);
        }, 0);
    }
    onDestroy() {
        App.vent.off("appwizard:retry:schema-validation");
    }

    async proceedTo(id) {
        const currentPage = `validate-${this.model.get("whatsInside")?.toLowerCase()}`;
        App.vent.trigger("appwizard:retry:hide");
        App.vent.trigger("appwizard:next:disable", currentPage);
        let step = this.collection.at(id);
        if (!step) {
            if (this.failed) {
                App.vent.trigger("appwizard:retry:show");
                return;
            }
            App.vent.trigger("appwizard:retry:hide");
            if ($(".connection-test-view").length > 0) {
                App.vent.trigger("appwizard:goForward", currentPage);
            }
            return;
        }
        let selectedSchema = step.get("selectedSchema");
        try {
            if (step.get("id").indexOf("::FETCH") !== -1) {
                await this.fetchTables(selectedSchema);
                step.set("status", "done");
            } else if (step.get("id").indexOf("::VALIDATE") !== -1) {
                await this.checkTableCompatibility(selectedSchema);
                step.set("status", "done");
            }
        } catch (e) {
            step.set("remedy", "System Error: " + e);
            step.set("status", "fail");
            Tracker.getInstance().track(TRACKER_STRINGS.schema.error, {
                id: step.get("id"),
                event: "Schema migration validation",
                message: e
            });
            this.failed = true;
        }
        id++;
        this.proceedTo(id);
    }

    async fetchTables(selectedSchema) {
        let type = this.model.get("type").toLowerCase();
        const username = this.model.get("connectionParams").get("username");
        let password = this.model.get("connectionParams").get("password");
        const wizardURL = this.model.get("connectionParams").getJDBCURL();
        let method = null;
        const agentName = this.model.get("connectionParams").get("agentName");
        const schema = selectedSchema.get("schemaName");

        return new Promise(async (resolve, reject) => {
            switch (type) {
                case "cosmosdb": {
                    password = this.model.get("connectionParams").get("accessKey");
                    const cosmosParams = { UserName: null, Password: password, ConnectionURL: wizardURL };
                    method = api.WizardHelper_GetTables("COSMOS", cosmosParams, schema + ".%", agentName);
                    break;
                }
                case "snowflake": {
                    const connectionProfileName = this.model.get("connectionParams").get("connectionProfileName");
                    method = api.WizardHelper_GetTables(
                        "SNOWFLAKE",
                        { useConnectionProfile: true, connectionProfileName: connectionProfileName },
                        schema + ".%",
                        agentName
                    );
                    break;
                }
                case "bigquery": {
                    const connectionProfileName = this.model.get("connectionParams").get("connectionProfileName");
                    const useConnectionProfile = this.model.get("connectionParams").get("useConnectionProfile");
                    const connectionUrl = this.model.get("connectionParams").get("connectionUrl");
                    method = api.WizardHelper_GetTables(
                        "BIGQUERY",
                        {
                            useConnectionProfile: useConnectionProfile,
                            connectionProfileName: connectionProfileName,
                            ConnectionURL: connectionUrl
                        },
                        schema + ".%",
                        agentName
                    );
                    break;
                }
                case "spanner": {
                    const connectionUrl = this.model.get("connectionParams").get("connectionUrl");
                    method = api.WizardHelper_GetTables(
                        "SPANNER",
                        { ConnectionURL: connectionUrl },
                        selectedSchema.get("schemaName") + ".%",
                        agentName
                    );
                    break;
                }

                default: {
                    const supportDownStreamCapture =
                        this.model.get("connectionParams").get("supportDownStreamCapture") ?? false;
                    let params;
                    if (this.model.get("type") == "OJET" && supportDownStreamCapture) {
                        params = await getParams(this.model.get("type"), this.model.get("connectionParams"), true);
                    } else {
                        params = await getParams(this.model.get("type"), this.model.get("connectionParams"));
                    }
                    let wizardType = type === "mongo_cosmosdb" ? "MONGOCOSMOS" : type.toUpperCase();
                    if (wizardType === "SQLSERVER" || wizardType === "MSJET") wizardType = "MSSQL";
                    else if (wizardType === "CRUNCHYDATA" || wizardType === "NEON") wizardType = "POSTGRES";
                    method = api.WizardHelper_GetTables(
                        wizardType,
                        params,
                        schema + ".%",
                        agentName
                    );
                }
            }

            method.then(
                async data => {
                    if (data.result === true) {
                         let tables = data.message;
                         this.prepareSchemasCollection(schema, tables);
                         this.setFetchingTablesStatus(selectedSchema, true);
                        resolve();
                    } else {
                        this.failAllPending(selectedSchema);
                        reject("Problem fetching Tables for " + selectedSchema.get("schemaName"));
                    }
                },
                () => {
                    this.failAllPending(selectedSchema);
                    reject("Problem fetching Tables for " + selectedSchema.get("schemaName"));
                }
            );
        });
    }

    async checkTableCompatibility(selectedSchema) {
        let type = this.model.get("type").toLowerCase();
        let agentName = this.model.get("connectionParams").get("agentName");
        const params = await getParams(type, this.model.get("connectionParams"));
        let tableCollection = selectedSchema.get("tables");
        let tableString = null;
        if (type.toLowerCase() === "sqlserver" || type.toLowerCase() === "msjet") {
            tableString =
                this.model.get("connectionParams").get("dbName") + "." + selectedSchema.get("schemaName") + ".%";
        } else {
            tableString = selectedSchema.get("schemaName") + ".%";
        }
        if ([DB_PROVIDERS.CRUNCHYDATA.id, DB_PROVIDERS.NEON.id].includes(type.toUpperCase())) {
            type = DB_PROVIDERS.POSTGRES.id.toLowerCase();
        }
        // Validate returns 2-part FQN (schema.table) but getTables stored 3-part (db.schema.table)
        // for Postgres/SQLServer/MSJet. Exact match first, then suffix match — tableCollection is
        // scoped to one schema so suffix collisions can't happen. Works for both CP and non-CP
        // flows since the db segment is recovered from stored IDs, not from connectionParams.dbName
        // (empty in CP path).
        const lookupTableModel = tableName => {
            return (
                tableCollection.findWhere({ id: tableName }) ||
                tableCollection.find(model => model.get("id").endsWith("." + tableName))
            );
        };
        return new Promise((resolve, reject) => {
            // Remove hard-code for target type to specify type based on selected wizard
            api.validateConvertSchema(type, params, this.model.getTargetType(), tableString, agentName).then(
                data => {
                    try {
                        let compatibility = data[selectedSchema.get("schemaName")];
                        if (!compatibility) {
                            return;
                        }
                        let successes = _.union(
                            compatibility["compatible"],
                            compatibility["compatibleWithIntelligence"]
                        );
                        _.each(successes, success => {
                            const tableModel = lookupTableModel(success.tableName);
                            if(tableModel){
                                tableModel.set("isValid", true);
                            }
                        });

                        let fails = _.union(compatibility["incompatible"]);
                        _.each(fails, fail => {
                            const tableModel = lookupTableModel(fail.tableName);
                            if(tableModel){
                                tableModel.set("isValid", false);
                                // Stores table level errors
                                tableModel.set("errors", fail);
                            }
                        });
                        this.setValidatingTableStatus(selectedSchema, true);
                        resolve();
                    } catch (e) {
                        console.error(e);
                        Tracker.getInstance().track(TRACKER_STRINGS.schema.error, {
                            id: selectedSchema.get("schemaName"),
                            event: "Validating tables",
                            message: e
                        });
                        this.setValidatingTableStatus(selectedSchema, false);
                        reject("Problem validating tables for  " + selectedSchema.get("schemaName") + `. ${e}`);
                    }
                },
                f => {
                    this.setValidatingTableStatus(selectedSchema, false);
                    reject("Problem validating tables for  " + selectedSchema.get("schemaName") + `. ${f}`);
                }
            );
        });
    }

    getName(table, type) {
        const chunks = table.split(".");
        if (
            ![DB_PROVIDERS.MONGODB.id, DB_PROVIDERS.MARIADBXPAND.id].includes(type) &&
            chunks.length === 3
        ) {
            // db.schema.<name>  →  drop db and schema
            return chunks.slice(2).join(".");
        }
        // schema.<name>  (or Mongo db.<collection.with.dots>)  →  drop first chunk only
        return chunks.slice(1).join(".");
    }   

    prepareSchemasCollection(schema, tables) {
        const schemasCollections = this.model.get("schemas");
        const currentSchemaCollection = schemasCollections?.findWhere({ schemaName: schema });
        const tableCollections = currentSchemaCollection?.get("tables");
        const dbType = this.model.get("type");
        const isMongoDB = dbType === DB_PROVIDERS.MONGODB.id;

        const tablesBySchema = [];
        tables.forEach(table => {
            if (isMongoDB && (table.indexOf("system.keys") !== -1 || table.indexOf("system.sessions") !== -1)) {
                return;
            }

            const name = this.getName(table, dbType);

            const tableModel = new Models.Table({
                id: table,
                name: name,
                fullTableName: table,
                isValid: true
            });
            tablesBySchema.push(tableModel);
        });
        tableCollections.add(tablesBySchema);
    }

    setFetchingTablesStatus(schema, value) {
        schema.set(statusKeys.FETCHING, value);
    }

    setValidatingTableStatus(schema, value) {
        schema.set(statusKeys.VALIDATING, value);
    }
    failAllPending(selectedSchema) {
        this.setFetchingTablesStatus(selectedSchema, false);
        this.setValidatingTableStatus(selectedSchema, false);
        // let remainders = this.collection.where({ status: "todo" });
        // _.each(remainders, model => {
        //     model.set("status", "fail");
        // });
        // App.vent.trigger("appwizard:retry:show");
    }

    canMoveForward() {
        let hasErrors = this.validationSteps.some(item => item.errors);
        return new Promise(function(resolve, reject) {
            if (!hasErrors) {
                resolve();
            } else {
                reject();
            }
        });
    }

    retry() {
        this.render();
    }
}